import { Controller } from "@hotwired/stimulus"

// Client-side filter over the full country list. The whole registry is already
// in the DOM (217 rows), so filtering is a class toggle rather than a fetch —
// and with JS off the page is still a complete grouped list of every country.
export default class extends Controller {
    static targets = ["filter", "row", "region", "empty"]

    filter() {
        const query = this.filterTarget.value.trim().toLowerCase()
        let visible = 0

        this.rowTargets.forEach((row) => {
            const match =
                query === "" ||
                row.dataset.name.includes(query) ||
                row.dataset.region.includes(query) ||
                row.dataset.iso === query
            row.hidden = !match
            if (match) visible += 1
        })

        // Hide a region heading once every country under it is filtered out.
        this.regionTargets.forEach((region) => {
            const rows = region.querySelectorAll("[data-country-picker-target='row']")
            region.hidden = Array.from(rows).every((row) => row.hidden)
        })

        if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0
    }
}
